// Polyfill for ReactDOM.findDOMNode removed in React 19
// This is a temporary workaround for libraries like react-draggable that still use it
import ReactDOM from 'react-dom';

if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (instance) => {
    if (instance == null) {
      return null;
    }
    if (instance.nodeType === 1) {
      return instance;
    }
    // For class components, try to get the underlying DOM node
    if (instance._reactInternals) {
      const fiber = instance._reactInternals;
      let node = fiber.stateNode;

      // If it's a HostComponent (DOM element), return it
      if (node && node.nodeType === 1) {
        return node;
      }

      // Otherwise, traverse to find the first DOM node
      let child = fiber.child;
      while (child) {
        if (child.stateNode && child.stateNode.nodeType === 1) {
          return child.stateNode;
        }
        child = child.child;
      }
    }

    console.warn(
      'findDOMNode is deprecated and has been removed in React 19. ' +
        'This polyfill is a temporary workaround. Please update react-draggable.',
    );
    return null;
  };
}
